import { useReactiveVar } from '@apollo/client'
import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import clsx from 'clsx'
import React, { FC, useCallback, useMemo } from 'react'
import { RadioType } from './AddProductTypes'
import {
    addProductDialogState,
    setProductDialogState,
} from './addProductFormHandler'
import { useAddProductFormStyles } from './formStyles'

const ProductTypeRadioSection: FC = () => {
    const {
        productTypeRadio,
        familyRadio,
        sectionNames,
        type,
        categories,
    } = useReactiveVar(addProductDialogState)

    const classes = useAddProductFormStyles()

    const isProductTypeDisabled = useMemo(
        () =>
            familyRadio === RadioType.New ? !categories.length : !sectionNames,
        [sectionNames, familyRadio, categories]
    )

    const handleProductTypeRadioChange = useCallback(
        (_, value) => {
            setProductDialogState({
                productTypeRadio: value,
                model: '',
                productType: '',
                productName: '',
                errors: {},
            })
        },
        [setProductDialogState]
    )

    return (
        <GridItem
            className={clsx(classes.rowContainer, 'rowContainer')}
            xs={12}
            data-testid="productTypeRadio"
        >
            <RadioGroup
                aria-label="Product Type Name Radio"
                value={productTypeRadio}
                name="productTypeRadio"
                row
                onChange={handleProductTypeRadioChange}
            >
                <FormControlLabel
                    control={<Radio color="primary" />}
                    value={RadioType.Existing}
                    label="Existing Product Type"
                    labelPlacement="end"
                    disabled={
                        isProductTypeDisabled || familyRadio === RadioType.New
                    }
                />
                <FormControlLabel
                    value={RadioType.New}
                    control={<Radio color="primary" />}
                    label={
                        type === ListingLevel.PremiumProprietary
                            ? 'New Product Type'
                            : 'New Manufacturer Product Type'
                    }
                    labelPlacement="end"
                    disabled={isProductTypeDisabled}
                />
            </RadioGroup>
        </GridItem>
    )
}

export default ProductTypeRadioSection
